module.exports = __webpack_public_path__ + "img/carosel.e6baaa83.jpg";